import React from 'react';
import Loader from '../components/loader';

export type WithInvalidState = {
  state?: unknown;
};

export const INVALID_STATE_LOADER_HOOK = 'widget-state-loader';

/**
 * The widget can be mounted before its controller has pushed the redux `state`
 * (the editor remounts widgets on Preview/Edit toggles, and the controller's
 * `setProps` only lands after routing + data fetching). Rendering a loader here
 * instead of throwing keeps that window out of the platform's error boundary,
 * which in Studio2 would otherwise flash a broken-component placeholder.
 */
export function withInvalidState<P extends WithInvalidState>(Component: React.ComponentType<P>) {
  return (props: P) => {
    if (!props.state) {
      return <Loader dataHook={INVALID_STATE_LOADER_HOOK} />;
    }

    return <Component {...props} />;
  };
}
